import { CmdbApplicationSchemaV1 } from './cmdb-application-schema';

export type SchemaRegistry = {
  id: string;
  version: string;
  title: string;
  description: string;
  schema: Record<string, any>;
};

// Add to registry as new schemas become available
const registeredSchemas = [CmdbApplicationSchemaV1];

export const schemaRegistry: SchemaRegistry[] = registeredSchemas.map((schema) => {
  const { id, title, version, description } = schema.registry
  const definition = schema.definition as Record<string, any>;
  const existingId = definition.$id as string | undefined;

  if (existingId && existingId !== id) {
    throw new Error(
      `Schema registry id mismatch for ${title} v${version}: registry id '${id}' does not match schema.definition.$id '${existingId}'.`
    );
  }

  return {
    id,
    version,
    title,
    description,
    // $id is required so the precompiled AJV validator can look up the
    // matching validate function at runtime (see scripts/precompile-validators.cjs).
    schema: { ...definition, $id: existingId || id },
  };
});
